<template>
  <div class="experiment ma-0">
    
    <div>
      <div class='my-2 title d-flex'>
        <span><v-img width="30px" :src='api.school_logo_url' /></span>
        <span v-if="$i18n.locale=='tc'" class='ml-2'> {{ api.school_chname }} </span>
        <span v-else class='ml-2'> {{ api.school_enname }} </span>
      </div>
    <router-view v-if="loaded"></router-view>
    </div>
    <v-overlay absolute :value="initialize">
      <v-progress-circular
        :size="50"
        :width="5"
        color="green accent-2"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import ExperimentBasic from "@/services/ExperimentBasic";

import {api_dds_booking} from '@/services/dds/api_dds_booking';
const apiDDSBooking = new api_dds_booking(process.env.VUE_APP_BASE_URL);

export default {
  name: "experiment",
  components: {
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      name: "",
      role: null,
      drawer: true,
      initialize: true,
      loaded: false,
      mini: true,
      school_code: "",
      api:{
        school_code: null,
        school_name: null,
        school_chi_name: null,
        school_logo_url: '',
      },      
    };
  },
  mounted: function () {
    this.name = 'iot';
    this.school_code = this.$route.params.school_code;

    var self = this;
        
    setTimeout(function(){
      if(self.$route.name == 'experiment'){
        console.log(self.$route.name);
      }
      else {
        console.log(self.$route.name);
      }
      self.initialization();
    },1000);
  },
  methods: {
    initialization(){
      var self = this;
      apiDDSBooking.getSchoolInfo(self.school_code)
      .then((response) => {
        if(response.status=='success') {
          self.api.school_code = response.school_code;
          self.api.school_enname = response.school_enname;
          self.api.school_chname = response.school_chname;
          if(JSON.parse(response.school_logo)!=null){
            self.api.school_logo_url = JSON.parse(response.school_logo).url;
          }
          else {
            self.api.school_logo_url = "";
          }
          self.loaded = true;
          self.initialize = false;
        }
        else {
          self.initialize = false;
          alert(response.error);
        }
      });
    },    
  },
  destroyed(){
    self.$cookies.remove("experiment");
    self.$cookies.remove("equipment_id");
    console.log("destroyed");
  } 
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>